import { STORAGE } from "../../constants";

/**
 * @name createScriptTag
 * @desc Creates a new script tag in order to load external APIs
 * @param {string} src The source URL for the script
 * @memberof utils
 */
export function createScriptTag(src) {
  const tag = window.document.createElement('script');
  tag.src = src;
  const firstScriptTag = window.document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

/**
 * @name generateBrowserTabId
 * @desc Generates a Browser tab ID based on existing local/session storage data
 * @memberof utils
 */
export const generateBrowserTabId = () => {
  const localStorageTabId = window.localStorage.getItem(STORAGE.TAB_ID_LOCAL);
  const sessionStorageTabId = window.sessionStorage.getItem(STORAGE.TAB_ID_SESSION);
  let tabId = sessionStorageTabId;

  // if it doesn't exist in session storage but it does in local storage
  if (!sessionStorageTabId && localStorageTabId) {
    const [timestamp, tabNumber] = localStorageTabId.split('_');
    const currentTabNumber = parseInt(tabNumber, 10) + 1;
    tabId = `${timestamp}_${currentTabNumber}`;
  } else if (!sessionStorageTabId && !localStorageTabId) {
    // if it doesn't exist in both storages, create the timestamp and append `_1` as the first open tab
    tabId = `${Date.now()}_1`;
  }

  // Save to both session and local storage
  window.localStorage.setItem(STORAGE.TAB_ID_LOCAL, tabId);
  window.sessionStorage.setItem(STORAGE.TAB_ID_SESSION, tabId);

  return tabId;
};
